var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMask = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.25C0 1.83579 0.335786 1.5 0.75 1.5C1.16421 1.5 1.5 1.83579 1.5 2.25V19.5C1.5 20.3284 2.17157 21 3 21H23.25C23.6642 21 24 21.3358 24 21.75C24 22.1642 23.6642 22.5 23.25 22.5H3C1.5 22.5 0 21 0 19.5V2.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 2.25L15.75 10.5L21 4.5L23.7972 17.0873C23.9013 17.5557 23.5448 18 23.065 18H5.25C4.83579 18 4.5 17.6642 4.5 17.25V9.75L10.5 2.25ZM10.5 4.8L15.75 12.75L20.25 7.5L22.2 16.5H6V10.5L10.5 4.8Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mask.15db905202c5d18e8ac36d500308bb59.svg";